import useJsonApi from "lib/useJsonApi.js";

function useSessionAppointments(sessionUuid) {
  return useJsonApi({
    url: `/api/session/${encodeURIComponent(sessionUuid)}/appointments`,
  });
}

export default useSessionAppointments;
